import { Container, NineSlicePlane, Text } from 'pixi.js';
import AssetsManager from '../../../core/assets/AssetsManager';
import LayoutBuilder from '../../../core/utils/LayoutBuilder';
import { autoscaleText } from '../../../core/utils/Utils';
import LayoutElement from '../../../core/view/model/LayoutElement';
import Button from '../../../core/view/ui/Button';
import { ERROR_CONSTANTS } from '../../../../jewels-of-wizard/services/GameConstant';

export default class PopupConnectionLost extends Container {

    private errorCode: string;
    private tfMessage: Text;
    private frame: NineSlicePlane;
    private pageRefresh: Button;
    private defaultErrorCode: string = 'CONNECTION_LOST';

    constructor(errorCode: string | (() => string)) {
        super();
        LayoutBuilder.create(AssetsManager.layouts.get('PopupLostConnection'), this, (le: LayoutElement) => {
            return this.customClassElementCreate(le);
        });

        this.errorCode = (errorCode instanceof Function ? errorCode() : errorCode) ?? this.defaultErrorCode;
        this.pageRefresh.on('pointerup', this.onPageRefresh, this);
        if(this.errorCode == ERROR_CONSTANTS.BET_AMOUNT_NOT_IN_LIMIT || this.errorCode == ERROR_CONSTANTS.INVALID_ROUND_ID || this.errorCode == ERROR_CONSTANTS.INVALID_GAME || this.errorCode === ERROR_CONSTANTS.ROUND_NOT_FINISHED || this.errorCode == ERROR_CONSTANTS.INVALID_SESSION){
            this.pageRefresh.visible = false;
            this.pageRefresh.setState(3);
        }else{
            this.pageRefresh.visible = true;
            this.pageRefresh.setState(0);
        }
        this.on('added', this.onAdded, this);
        this.on('removed', this.onRemoved, this);
    }

    private customClassElementCreate(le: LayoutElement): unknown {
        let instance: unknown = null;

        switch (le.customClass) {
            case 'Button':
                instance = new Button(le);
                break;
        }

        return instance;
    }

    private onPageRefresh(): void {
        location.reload();
    }

    private onAdded(): void {
        this.tfMessage.text = AssetsManager.translations.get(`errorMessages.${this.errorCode}`) ?? AssetsManager.translations.get(`errorMessages.${this.defaultErrorCode}`);
        autoscaleText(this.tfMessage, 54, this.frame.width * 0.95, 70);
    }

    private onRemoved(): void {

    }
}
